import { Link } from "react-router-dom";

import ModuleShell from "../../components/director/module1/ModuleShell";
import { FRESHNESS_LABELS } from "../../components/director/page/freshness";
import { useDirectorContext } from "@contexts/director";
import { companyQuery } from "./module1Utils";
import {
  COMPLEMENTARY_LABEL,
  pagePath,
  visibleComplementarySections,
} from "./complementaryPages";

/**
 * Página de entrada de Informações complementares (spec `director/workspace-navigation`): três
 * seções, e em cada cartão a pergunta que a página responde. Só entram as páginas que o perfil
 * pode abrir (a mesma capability da rota).
 */
const Complementary = () => {
  const { selectedCompanyId, accessByCompany = {}, refreshStatus = null } = useDirectorContext();
  const capabilities = accessByCompany[selectedCompanyId]?.capabilities || [];
  const sections = visibleComplementarySections(capabilities);
  const query = companyQuery(selectedCompanyId);
  const refreshLabel = refreshStatus ? FRESHNESS_LABELS[refreshStatus.state] : null;

  return <ModuleShell
    title={COMPLEMENTARY_LABEL}
    description="Para aprofundar uma resposta, ajustar premissas ou conferir os dados."
    showProjectFilter={false}
  >
    <div className="director-complementary">
      {sections.map((section) => <section
        className="director-complementary__section"
        key={section.key}
        aria-labelledby={`director-complementary-${section.key}`}
      >
        <h2 id={`director-complementary-${section.key}`}>{section.title}</h2>
        <ul className="director-complementary__grid">
          {section.pages.map((page) => <li key={page.key}>
            <Link className="director-complementary__card" to={`${pagePath(page)}${query}`}>
              <strong>{page.label}</strong>
              <span>{page.question}</span>
              {page.key === "refresh-status" && refreshLabel && <span data-state={refreshStatus.state}>
                {`Agora: ${refreshLabel}`}
              </span>}
            </Link>
          </li>)}
        </ul>
      </section>)}
    </div>
  </ModuleShell>;
};

export default Complementary;
